// Single source of truth for Eveniment Lives shown across the site
// (used by PloomEventNew on home and PloomEventsList on /evenimente).
const events = [
  // {
  //   id: "inner-cluj",
  //   title: "The Inner Cluj-Napoca",
  //   location: "Cinema Florin Piersic, Cluj",
  //   date: "5-7 Iunie 2026",
  //   time: "9:00 - 14:00",
  //   description:
  //     "Un weekend imersiv dedicat conexiunii cu sine, prin uleiuri esențiale, respirație și rituale de wellbeing.",
  //   link: "/campanie/cluj",
  //   featured: true,
  //   active: true,
  //   eventType: "Fizic",
  //   coverImage: "",
  // },
  // {
  //   id: "sibiu",
  //   title: "Campanie Sibiu",
  //   location: "Piața Mare, Sibiu",
  //   date: "22-24 Aprilie 2026",
  //   time: "09:00 - 17:00",
  //   description:
  //     "Sesiuni deschise în aer liber unde poți testa uleiurile, primi consultanță și descoperi rutina ta personalizată.",
  //   link: "/campanie/sibiu",
  //   featured: false,
  //   active: true,
  //   eventType: "Fizic",
  //   coverImage: "",
  // },
  // {
  //   id: "cluj-mai",
  //   title: "Campanie Cluj",
  //   location: "Piața Unirii, Cluj-Napoca",
  //   date: "5-7 Mai 2026",
  //   time: "10:00 - 18:00",
  //   description:
  //     "Trei zile de aromaterapie aplicată, cu blenduri create pe loc și recomandări pentru fiecare obiectiv.",
  //   link: "/campanie/cluj",
  //   featured: false,
  //   active: true,
  //   eventType: "Fizic",
  //   coverImage: "",
  // },
  // {
  //   id: "timisoara",
  //   title: "Campanie Timișoara",
  //   location: "Piața Victoriei, Timișoara",
  //   date: "12-14 Iunie 2026",
  //   time: "10:00 - 18:00",
  //   description:
  //     "Un eveniment dedicat celor care vor să descopere stilul de viață natural prin uleiuri esențiale pure.",
  //   link: "/campanie/timisoara",
  //   featured: false,
  //   active: true,
  //   eventType: "Fizic",
  //   coverImage: "",
  // },
  // {
  //   id: "bucuresti",
  //   title: "Campanie București",
  //   location: "Centrul vechi, București",
  //   date: "3-5 Iulie 2026",
  //   time: "11:00 - 19:00",
  //   description:
  //     "O zi 1:1 pentru a-ți alege rutina potrivită — fie pentru somn, focus, calmare sau energie.",
  //   link: "/campanie/bucuresti",
  //   featured: false,
  //   active: true,
  //   eventType: "Fizic",
  //   coverImage: "",
  // },
];

export const getActiveEvents = () => events.filter((e) => e.active);

export default events;
